var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activation"},[_c('div',{staticClass:"EchatsBox",staticStyle:{"height":"322px"}},[_c('div',{staticClass:"EchatsImg",staticStyle:{"height":"322px"},attrs:{"id":_vm.EchatsId}})])])}
var staticRenderFns = []

export { render, staticRenderFns }